
  <div class="flex items-center p-6">
    <img src="/assets/images/infoIcon.svg">
    <h6 class="mr-4 font-bold text-xl flex-grow">فیلترها</h6>
    <i (click)="dialogRef.close()" class="ico-Close cursor-pointer text-xl "></i>
  </div>

  <div class="h-[1px] w-full bg-[#FCFCFC]"></div>
  
  <div class="md:h-[55vh] overflow-auto">
    <mat-accordion [multi]="false" class="filters-sidebar-accordion !text-black w-full flex flex-col">
      <ng-container   *ngFor="let item of data.dataSource;let first = first;let last = last;let i = index">
        <mat-expansion-panel
        *ngIf="item.Items.length"
        [expanded]="expandedIndex === i" class="border-bottom">
          <mat-expansion-panel-header class="!px-6">
            <mat-panel-title>
              <ng-container [ngSwitch]="item.Key">
                <ng-container *ngSwitchCase="'labelsAccomodate'">
                  <i class="ico-ticket text-lg"></i>
                </ng-container>
                <ng-container *ngSwitchCase="'price'">
                  <i class="ico-tag-dollar text-lg"></i>
                </ng-container>
                <ng-container *ngSwitchCase="'hotelTypes'">
                  <i class="ico-house text-lg"></i>
                </ng-container>
                <ng-container *ngSwitchCase="'hotelStyles'">
                  <i class="ico-beach text-lg"></i>
                </ng-container>
                <ng-container *ngSwitchCase="'facilities'">
                  <i class="ico-Filter2 text-lg"></i>
                </ng-container>
                <ng-container *ngSwitchCase="'rules'">
                  <i class="ico-InformationSquare text-lg"></i>
                </ng-container>
              </ng-container>
              <p class="text-dark-500 text-base mr-2">{{ item.Key === 'labels' ? 'فیلتر ها' : item.Title }}</p>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div [ngSwitch]="item.Key" class="px-6">
            <div *ngSwitchCase="'labelsAccomodate'">
              <iho-labels-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'labels'">
              <iho-labels-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'reviews'">
              <iho-comments-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'grades'">
              <iho-stars-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
        
        
            <div *ngSwitchCase="'types'">
              <iho-residence-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'hotelTypes'">
              <iho-residence-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'price'">
              <ng-container *ngIf="showPriceFilter()">
                <iho-price-filter [_reset]="reset()" (checkedMinValue)="MinValue($event)" (checkedMaxValue)="MaxValue($event)"
                  [_minValue]="minPriceFilterInit!" [_maxValue]="maxPriceFilterInit!" [dataSource]="item.Items" />
              </ng-container>
            </div>
            <div *ngSwitchCase="'hotelStyles'">
              <iho-type-of-location-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
        
        
            <div *ngSwitchCase="'facilities'">
              <iho-accommodation-facilities-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'rules'">
              <iho-rules-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
          </div>
        </mat-expansion-panel>
      </ng-container>
      
    </mat-accordion>
  </div>

  <div class="p-6">
    <button [disabled]="!activeFiltersLength"
    [class.!text-[#6C96F2]]="!activeFiltersLength"
    [ngClass]="{'hover:bg-[#2463EB] hover:bg-opacity-30': activeFiltersLength}" (click)="setFilters()" class="rounded text-[#2463EB] px-4 py-1.5 transition">
      اعمال فیلتر ها
    </button>
    <button [disabled]="!showRemoveBtn"  (click)="removeAllFilters()" class="mr-3 rounded bg-[#FF4242] bg-opacity-20 text-[#FF4242] px-2 py-1.5 transition"
    [ngClass]="{'hover:!bg-[#FF4242] hover:!bg-opacity-30': showRemoveBtn, '!bg-[#FF4242] !bg-opacity-10 !text-[#FF8080]' : !showRemoveBtn}">
      حذف فیلتر ها
    </button>
  </div>

